<template>
  <div class="wrapper">
    <div class="block-center mt-4 wd-xxl">
      <div class="text-center mt-4 mb-4">
        <a href="../" title="TLT"> <img src="/static/logo.png" alt="TLT logo" class="tbt-logo"></a>
      </div>
      <div class="card card-flat">
        <div class="card-header text-center bg-dark-green">
          <router-link :to="{name: 'tenders'}">
            <h4 class="text-white m-0">{{ $t('global.client-name') }}</h4>
          </router-link>
        </div>
        <div class="card-body">
          <form @submit.prevent="recover" class="form-modal form-recover">
            <p class="text-center py-2">{{ $t('recover.recover-title') }}</p>
            <div class="form-group">
              <label class="text-muted">{{ $t('recover.email') }}</label>
              <div class="form-group">
                <div class="input-group with-focus">
                  <input
                    v-model="email"
                    :class="{'parsley-error': errors.email}"
                    id="email"
                    autocomplete="off"
                    class="form-control border-right-0"
                    :placeholder="$t('recover.email')"
                    type="email"
                    required>
                  <div class="input-group-append">
                    <span
                      class="input-group-text text-muted bg-transparent border-left-0"
                      :class="{'parsley-error': errors.email}">
                      <em class="fa fa-envelope"></em>
                    </span>
                  </div>
                </div>
                <ul class="parsley-errors-list filled" v-if="errors.email">
                  <li class="parsley-required">{{ errors.email[0] }}</li>
                </ul>
              </div>
            </div>
            <button
              class="btn btn-success btn-block"
              type="submit"
              :disabled="disabled">{{ $t('recover.change') }}
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="p-3 text-center">
      <span>{{ $t('global.soft-year') }} {{ $t('global.soft-name') }}</span>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import message from '@/message'
import {parseApiError} from '@/utils'

export default {
  data () {
    return {
      email: null,
      errors: {},
      disabled: false
    }
  },
  methods: {
    recover () {
      this.disabled = true
      this.errors = {}
      api.post('/forgot_password/', {
        email: this.email
      })
        .then(() => {
          message.success('Aktiveerimis link saadetud e-postile')
          this.$router.push({path: '/'})
        })
        .catch(error => {
          this.disabled = false
          let errors = parseApiError(error, this.$i18n)
          if (error.response && error.response.status === 400) {
            this.errors = errors
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Recover.vue